import React from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const FinalCTA = React.forwardRef<HTMLElement>((_props, ref) => {
  return (
    <section ref={ref} className="relative py-24 md:py-32 px-6 overflow-hidden">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[400px] bg-primary/[0.03] blur-[150px] rounded-full pointer-events-none" />

      <div className="max-w-3xl mx-auto text-center">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          <h2 className="font-display font-extrabold text-4xl md:text-6xl lg:text-7xl text-foreground leading-[1.05] tracking-tight mb-6">
            Stop guessing.
            <br />
            <span className="text-primary text-glow-cyan-strong">Start seeing.</span>
          </h2>
          <p className="text-muted-foreground font-mono text-sm mb-8 max-w-md mx-auto leading-relaxed">
            Every day without BotSweep is another day of corrupted data and wasted budget.
          </p>
          <Link to="/auth">
            <Button
              size="lg"
              className="btn-shimmer bg-primary text-primary-foreground hover:bg-primary/90 glow-cyan-strong px-10 h-14 text-sm font-display font-semibold tracking-wide group"
            >
              Start Free — Takes 30 Seconds
              <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
            </Button>
          </Link>
          <p className="text-[10px] text-muted-foreground font-mono mt-5 tracking-wider">
            No credit card · Free plan · Cancel anytime
          </p>
        </motion.div>
      </div>
    </section>
  );
});

FinalCTA.displayName = "FinalCTA";

export default FinalCTA;
